import { KeyValueType } from '@models/common';

export enum AdjustmentType {
  None = 0,
  Recurring = 1,
  OneTime = 2,
  Accrual = 3,
}

export enum AdjustmentTerm {
  None = 0,
  Charge = 1,
  Bonus = 2,
}

export enum AdjustmentValueType {
  Amount = 1,
  Percentage = 2,
}

export type AdjustmentReleaseModel = {
  id: number;
  adjustmentId: number;
  /** The released money. The only value the server stores — a percentage is converted on save. */
  amount?: number;
  /**
   * Write only. On read the server fills this from the **parent adjustment's** rate
   * (`Percentage = r.Adjustment.AdjustmentPercentage`), so it says nothing about this release.
   */
  percentage?: number;
  comment?: string;
  paymentPeriodId?: number;
  paymentPeriodStart?: string;
  paymentPeriodEnd?: string;
  lastUpdatedDate?: string;
  isAutogenerated?: boolean;
  adjustmentName?: string;
  adjustmentCategory?: string;
};

export type AdjustmentRequest = {
  id?: number;
  contractId?: number;
  entityInstanceId?: number;
  name: string;
  categoryId: number;
  description?: string;
  comment?: string;
  amount?: number;
  percentage?: number;
  type: AdjustmentType;
  class: AdjustmentTerm;
  start?: string;
  end?: string;
  willBeRetained?: boolean;
  frequency?: number;
  sovs?: KeyValueType<number, string>[];
};

export type AdjustmentModel = AdjustmentRequest & {
  id: number;
  categoryName?: string;
  typeName?: string;
  /** Recurring and Accrual always; One Time only when it is a Charge. */
  allowsReleases: boolean;
  retainedAmount?: number;
  releasedAmount?: number;
  paidAmount?: number;
  remainingAmount?: number;
  remainingReleaseAmount?: number;
  releases?: AdjustmentReleaseModel[];
  currentPeriodEndDate?: string;
};
